import React from 'react';

import Spinner from '../../../components/UI/Spinner/Spinner';
import Message from './Message';
import Card from '../../../components/UI/Card/Card';
import styles from './Messages.module.css';

const Messages = (props) => {

  let content;
  if ( props.messages ){
    content = props.messages.length > 0
                ? props.messages.map( m => <Message key={m.id} message={m} /> )
                : <div className={styles.no_message}>Bisher keine Nachrichten erhalten</div> 
  } else {
    content = <div style={{height: '60px'}}> <Spinner /> </div>
  }

  
                  

  return <>
           <div className={styles.messages} >
             <h3 style={{textAlign: 'center'}}>Benachrichtigungen</h3>
             {content}
           </div>
        </>
}

export default Messages;